import { FunctionComponent, SVGProps } from 'react';

import ARROW_DOWN_SVG from './assets/arrow-down.icon.svg';
import ARROW_RIGHT_SVG from './assets/arrow-right.icon.svg';
import ASTERISK_SVG from './assets/asterisk.icon.svg';
import BOLT_SVG from './assets/bolt.icon.svg';
import CALENDAR_SVG from './assets/calendar.icon.svg';
import CHAT_SVG from './assets/chat.icon.svg';
import CHECK_SVG from './assets/check.icon.svg';
import CHEVRON_DOWN_SVG from './assets/chevron-down.icon.svg';
import CHEVRON_LEFT_SVG from './assets/chevron-left.icon.svg';
import CHEVRON_RIGHT_SVG from './assets/chevron-right.icon.svg';
import CHEVRON_UP_SVG from './assets/chevron-up.icon.svg';
import CLOSE_MENU_SVG from './assets/close-menu.icon.svg';
import CLOSE_SVG from './assets/close.icon.svg';
import CONFIRM_SVG from './assets/confirm.icon.svg';
import COPY_SVG from './assets/copy.icon.svg';
import DIRECTION_DOWN_SVG from './assets/direction-down.icon.svg';
import DOCUMENT_SVG from './assets/document.icon.svg';
import DOUBLE_CHEVRON_RIGHT_SVG from './assets/double-chevron-right.icon.svg';
import DOWN_SVG from './assets/down.icon.svg';
import DOWNLOAD_SVG from './assets/download.icon.svg';
import DRAG_HANDLE_SVG from './assets/drag-handle.icon.svg';
import EDIT_FILE_SVG from './assets/edit-file.icon.svg';
import EDIT_SVG from './assets/edit.icon.svg';
import ERROR_SVG from './assets/error.icon.svg';
import EYE_SVG from './assets/eye.icon.svg';
import FILE_SVG from './assets/file.icon.svg';
import FILTER_SVG from './assets/filter.icon.svg';
import FIRE_SVG from './assets/fire.icon.svg';
import GRID_SVG from './assets/grid.icon.svg';
import GROUP_SVG from './assets/group.icon.svg';
import HOME_SVG from './assets/home.icon.svg';
import HOT_SVG from './assets/hot.icon.svg';
import INFO_SVG from './assets/info.icon.svg';
import INPUT_SVG from './assets/input.icon.svg';
import AZURE_DEVOPS_SVG from './assets/integration-assets/azure-devops.icon.svg';
import DROPBOX_SVG from './assets/integration-assets/dropbox.icon.svg';
import GITHUB_ISSUES_SVG from './assets/integration-assets/github-issues.icon.svg';
import GOOGLE_DRIVE_SVG from './assets/integration-assets/google-drive.icon.svg';
import GOOGLE_SVG from './assets/integration-assets/google.icon.svg';
import JIRA_SVG from './assets/integration-assets/jira.icon.svg';
import LINEAR_SVG from './assets/integration-assets/linear.icon.svg';
import MICROSOFT_SVG from './assets/integration-assets/microsoft.icon.svg';
import OKTA_SVG from './assets/integration-assets/okta.icon.svg';
import SERVICENOW_SVG from './assets/integration-assets/service-now.icon.svg';
import SLACK_SVG from './assets/integration-assets/slack.icon.svg';
import ZENDESK_SVG from './assets/integration-assets/zendesk.icon.svg';
import LIBRARY_SVG from './assets/library.icon.svg';
import LINK_SVG from './assets/link.icon.svg';
import LOADING_SVG from './assets/loading.svg';
import LOCK_FILLED_SVG from './assets/lock-filled.icon.svg';
import LOCK_SVG from './assets/lock.icon.svg';
import LOGOUT_SVG from './assets/logout.icon.svg';
import MENU_LEFT_ARROW_SVG from './assets/menu-left-arrow.icon.svg';
import MENU_RIGHT_ARROW_SVG from './assets/menu-right-arrow.icon.svg';
import MENU_SVG from './assets/menu.icon.svg';
import MICROPHONE_SVG from './assets/microphone.icon.svg';
import MINIMIZE_SVG from './assets/minimize.icon.svg';
import MINUS_SVG from './assets/minus.icon.svg';
import MORE_SVG from './assets/more.icon.svg';
import NEW_CHAT_SVG from './assets/new-chat.icon.svg';
import OPEN_MENU_SVG from './assets/open-menu.icon.svg';
import PLAY_SVG from './assets/play.icon.svg';
import PLUS_CIRCLE_SVG from './assets/plus-circle.icon.svg';
import PLUS_SVG from './assets/plus.icon.svg';
import PROFILE_SVG from './assets/profile.icon.svg';
import QUICK_NAV_BLOCK_SVG from './assets/quick-nav-block.icon.svg';
import QUICK_NAV_LINE_SVG from './assets/quick-nav-line.icon.svg';
import QUICK_NAV_SVG from './assets/quick-nav.icon.svg';
import RELOAD_SVG from './assets/reload.icon.svg';
import SAVE_SVG from './assets/save.icon.svg';
import SEARCH_SVG from './assets/search.icon.svg';
import SEND_SVG from './assets/send.icon.svg';
import SETTINGS_SVG from './assets/settings.icon.svg';
import SHARE_SVG from './assets/share.icon.svg';
import SPARKLES_SVG from './assets/sparkles.icon.svg';
import STORAGE_SVG from './assets/storage.icon.svg';
import SUPPORT_SVG from './assets/support.icon.svg';
import TEST_SVG from './assets/test.icon.svg';
import THUMBS_DOWN_SVG from './assets/thumbs-down.icon.svg';
import THUMBS_UP_SVG from './assets/thumbs-up.icon.svg';
import TOOLS_SVG from './assets/tools.icon.svg';
import TRASH_SVG from './assets/trash.icon.svg';
import UP_SVG from './assets/up.icon.svg';
import UPLOAD_SVG from './assets/upload.icon.svg';
import WARNING_SVG from './assets/warning.icon.svg';
export enum Icon {
  ARROW_DOWN = 'ARROW_DOWN',
  ARROW_RIGHT = 'ARROW_RIGHT',
  ASTERISK = 'ASTERISK',
  AZURE_DEVOPS = 'AZURE_DEVOPS',
  BOLT = 'BOLT',
  CALENDAR = 'CALENDAR',
  CHAT = 'CHAT',
  CHECK = 'CHECK',
  CHEVRON_DOWN = 'CHEVRON_DOWN',
  CHEVRON_LEFT = 'CHEVRON_LEFT',
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
  CHEVRON_UP = 'CHEVRON_UP',
  CLOSE = 'CLOSE',
  CLOSE_MENU = 'CLOSE_MENU',
  CONFIRM = 'CONFIRM',
  COPY = 'COPY',
  DIRECTION_DOWN = 'DIRECTION_DOWN',
  DOCUMENT = 'DOCUMENT',
  DOUBLE_CHEVRON_RIGHT = 'DOUBLE_CHEVRON_RIGHT',
  DOWN = 'DOWN',
  DOWNLOAD = 'DOWNLOAD',
  DRAG_HANDLE = 'DRAG_HANDLE',
  DROPBOX = 'DROPBOX',
  EDIT = 'EDIT',
  EDIT_FILE = 'EDIT_FILE',
  ERROR = 'ERROR',
  EYE = 'EYE',
  FILE = 'FILE',
  FILTER = 'FILTER',
  FIRE = 'FIRE',
  GITHUB_ISSUES = 'GITHUB_ISSUES',
  GOOGLE = 'GOOGLE',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
  GRID = 'GRID',
  GROUP = 'GROUP',
  HOME = 'HOME',
  HOT = 'HOT',
  INFO = 'INFO',
  INPUT = 'INPUT',
  JIRA = 'JIRA',
  LIBRARY = 'LIBRARY',
  LINEAR = 'LINEAR',
  LINK = 'LINK',
  LOADING = 'LOADING',
  LOCK = 'LOCK',
  LOCK_FILLED = 'LOCK_FILLED',
  LOGOUT = 'LOGOUT',
  MENU = 'MENU',
  MENU_LEFT_ARROW = 'MENU_LEFT_ARROW',
  MENU_RIGHT_ARROW = 'MENU_RIGHT_ARROW',
  MICROPHONE = 'MICROPHONE',
  MICROSOFT = 'MICROSOFT',
  MINIMIZE = 'MINIMIZE',
  MINUS = 'MINUS',
  MORE = 'MORE',
  NEW_CHAT = 'NEW_CHAT',
  OKTA = 'OKTA',
  OPEN_MENU = 'OPEN_MENU',
  PLAY = 'PLAY',
  PLUS = 'PLUS',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PROFILE = 'PROFILE',
  QUICK_NAV = 'QUICK_NAV',
  QUICK_NAV_BLOCK = 'QUICK_NAV_BLOCK',
  QUICK_NAV_LINE = 'QUICK_NAV_LINE',
  RELOAD = 'RELOAD',
  SAVE = 'SAVE',
  SEARCH = 'SEARCH',
  SEND = 'SEND',
  SERVICENOW = 'SERVICENOW',
  SETTINGS = 'SETTINGS',
  SHARE = 'SHARE',
  SLACK = 'SLACK',
  SPARKLES = 'SPARKLES',
  STORAGE = 'STORAGE',
  SUPPORT = 'SUPPORT',
  TEST = 'TEST',
  THUMBS_DOWN = 'THUMBS_DOWN',
  THUMBS_UP = 'THUMBS_UP',
  TOOLS = 'TOOLS',
  TRASH = 'TRASH',
  UP = 'UP',
  UPLOAD = 'UPLOAD',
  WARNING = 'WARNING',
  ZENDESK = 'ZENDESK'
}

export const ICON_SVGS: Record<
  Icon,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  [Icon.ARROW_DOWN]: ARROW_DOWN_SVG,
  [Icon.ARROW_RIGHT]: ARROW_RIGHT_SVG,
  [Icon.ASTERISK]: ASTERISK_SVG,
  [Icon.AZURE_DEVOPS]: AZURE_DEVOPS_SVG,
  [Icon.BOLT]: BOLT_SVG,
  [Icon.CALENDAR]: CALENDAR_SVG,
  [Icon.CHAT]: CHAT_SVG,
  [Icon.CHECK]: CHECK_SVG,
  [Icon.CHEVRON_DOWN]: CHEVRON_DOWN_SVG,
  [Icon.CHEVRON_LEFT]: CHEVRON_LEFT_SVG,
  [Icon.CHEVRON_RIGHT]: CHEVRON_RIGHT_SVG,
  [Icon.CHEVRON_UP]: CHEVRON_UP_SVG,
  [Icon.CLOSE]: CLOSE_SVG,
  [Icon.CLOSE_MENU]: CLOSE_MENU_SVG,
  [Icon.CONFIRM]: CONFIRM_SVG,
  [Icon.COPY]: COPY_SVG,
  [Icon.DIRECTION_DOWN]: DIRECTION_DOWN_SVG,
  [Icon.DOCUMENT]: DOCUMENT_SVG,
  [Icon.DOUBLE_CHEVRON_RIGHT]: DOUBLE_CHEVRON_RIGHT_SVG,
  [Icon.DOWN]: DOWN_SVG,
  [Icon.DOWNLOAD]: DOWNLOAD_SVG,
  [Icon.DRAG_HANDLE]: DRAG_HANDLE_SVG,
  [Icon.DROPBOX]: DROPBOX_SVG,
  [Icon.EDIT]: EDIT_SVG,
  [Icon.EDIT_FILE]: EDIT_FILE_SVG,
  [Icon.ERROR]: ERROR_SVG,
  [Icon.EYE]: EYE_SVG,
  [Icon.FILE]: FILE_SVG,
  [Icon.FILTER]: FILTER_SVG,
  [Icon.FIRE]: FIRE_SVG,
  [Icon.GITHUB_ISSUES]: GITHUB_ISSUES_SVG,
  [Icon.GOOGLE]: GOOGLE_SVG,
  [Icon.GOOGLE_DRIVE]: GOOGLE_DRIVE_SVG,
  [Icon.GRID]: GRID_SVG,
  [Icon.GROUP]: GROUP_SVG,
  [Icon.HOME]: HOME_SVG,
  [Icon.HOT]: HOT_SVG,
  [Icon.INFO]: INFO_SVG,
  [Icon.INPUT]: INPUT_SVG,
  [Icon.JIRA]: JIRA_SVG,
  [Icon.LIBRARY]: LIBRARY_SVG,
  [Icon.LINEAR]: LINEAR_SVG,
  [Icon.LINK]: LINK_SVG,
  [Icon.LOADING]: LOADING_SVG,
  [Icon.LOCK]: LOCK_SVG,
  [Icon.LOCK_FILLED]: LOCK_FILLED_SVG,
  [Icon.LOGOUT]: LOGOUT_SVG,
  [Icon.MENU]: MENU_SVG,
  [Icon.MENU_LEFT_ARROW]: MENU_LEFT_ARROW_SVG,
  [Icon.MENU_RIGHT_ARROW]: MENU_RIGHT_ARROW_SVG,
  [Icon.MICROPHONE]: MICROPHONE_SVG,
  [Icon.MICROSOFT]: MICROSOFT_SVG,
  [Icon.MINIMIZE]: MINIMIZE_SVG,
  [Icon.MINUS]: MINUS_SVG,
  [Icon.MORE]: MORE_SVG,
  [Icon.NEW_CHAT]: NEW_CHAT_SVG,
  [Icon.OKTA]: OKTA_SVG,
  [Icon.OPEN_MENU]: OPEN_MENU_SVG,
  [Icon.PLAY]: PLAY_SVG,
  [Icon.PLUS]: PLUS_SVG,
  [Icon.PLUS_CIRCLE]: PLUS_CIRCLE_SVG,
  [Icon.PROFILE]: PROFILE_SVG,
  [Icon.QUICK_NAV]: QUICK_NAV_SVG,
  [Icon.QUICK_NAV_BLOCK]: QUICK_NAV_BLOCK_SVG,
  [Icon.QUICK_NAV_LINE]: QUICK_NAV_LINE_SVG,
  [Icon.RELOAD]: RELOAD_SVG,
  [Icon.SAVE]: SAVE_SVG,
  [Icon.SEARCH]: SEARCH_SVG,
  [Icon.SEND]: SEND_SVG,
  [Icon.SERVICENOW]: SERVICENOW_SVG,
  [Icon.SETTINGS]: SETTINGS_SVG,
  [Icon.SHARE]: SHARE_SVG,
  [Icon.SLACK]: SLACK_SVG,
  [Icon.SPARKLES]: SPARKLES_SVG,
  [Icon.STORAGE]: STORAGE_SVG,
  [Icon.SUPPORT]: SUPPORT_SVG,
  [Icon.TEST]: TEST_SVG,
  [Icon.THUMBS_DOWN]: THUMBS_DOWN_SVG,
  [Icon.THUMBS_UP]: THUMBS_UP_SVG,
  [Icon.TOOLS]: TOOLS_SVG,
  [Icon.TRASH]: TRASH_SVG,
  [Icon.UP]: UP_SVG,
  [Icon.UPLOAD]: UPLOAD_SVG,
  [Icon.WARNING]: WARNING_SVG,
  [Icon.ZENDESK]: ZENDESK_SVG
};
